module.exports = __webpack_public_path__ + "img/singup6.ee58fdb6.jpg";